export default __webpack_public_path__ + "static/project-slide-1-992-765-689fece37591d511be2dbdfee2e445b3.jpg";